module.exports = __webpack_public_path__ + "img/notifications.c4edf204.png";